import React from "react";
import styled from "styled-components";

const SDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const SImg = styled.img`
  justify-content: center;
  resize: contain;
  max-height: 60vh;
  max-width: 80vw;
`;

export default class NotFound extends React.Component {
  render() {
    return (
      <SDiv>
        <SImg src={process.env.PUBLIC_URL + "/logo_lrg.png"} alt="form" />
        <a href="/">
          <p style={{ width: "100%" }}>Are you lost? Try going home</p>
        </a>
        <p style={{ width: "60%" }}>404 - Not Found</p>
      </SDiv>
    );
  }
}
